// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wK7S","type":"styles_type__6T7eT","choices":"styles_choices__1bX0l"};